export function validateCianDomain(url: string) {
  const parsedUrl = new URL(url, 'https://www.cian.ru/');
  const hostname = parsedUrl.hostname || '';

  return hostname.endsWith('.cian.ru');
}
